export default "__VITE_ASSET__y4Xx3l4O__"